import { Box } from '@mui/material';
import React from 'react';
import _ from 'lodash';

export interface LabelAndElementRow {
    label: string | JSX.Element;
    labelSize?: number;
    labelWeight?: number;
    element: string | JSX.Element;
}

interface LabelsAndElementsProps {
    rows: Array<LabelAndElementRow>;
    labelWidth?: number;
    styles?: object;
    gap?: number;
}

const LabelsAndElements: React.FC<LabelsAndElementsProps> = ({ rows, labelWidth, styles, gap }) => {
    const defaultStyles = {};
    const mergedStyles = styles ? _.merge(defaultStyles, styles) : defaultStyles;
    const finalLabelWidth = labelWidth || 150;
    return (
        <Box sx={mergedStyles}>
            {rows.map((row, index) => {
                return (
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', mt: index ? (gap || gap === 0 ? gap : 3) : 0 }}
                        key={index}
                    >
                        <Box
                            sx={{
                                width: `${finalLabelWidth}px`,
                                fontSize: `${row.labelSize || 14}px`,
                                fontWeight: `${row.labelWeight || 400}`,
                            }}
                            className="color-md"
                        >
                            {row.label}
                        </Box>
                        <Box
                            sx={{
                                'width': `calc(100% - ${finalLabelWidth}px)`,
                                'display': '-webkit-box',
                                'WebkitBoxOrient': 'vertical',
                                '& div': { overflow: 'hidden', textOverflow: 'ellipsis' },
                            }}
                        >
                            {row.element}
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};

export default LabelsAndElements;
